import React, { useMemo, useRef } from 'react';
import { JiraEntryPointContainer } from '@jira/platform__entry-points-container/src/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
import { useEntryPoint } from '@jira/platform__entry-point/src/controllers/use-entry-point/index.tsx';
import { jpdBlueprintsFeedbackBannerEntryPoint } from './jpdBlueprintsFeedbackBannerEntryPoint.entrypoint.tsx';
import { ENTRY_POINT_ID, PACKAGE_NAME } from './bannerName.constants.tsx';

const useEntrypoint = () => {
	const entryPointParams = useMemo(() => {
		return {};
	}, []);
	const hasLoadedEntrypoint = useRef(false);
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		jpdBlueprintsFeedbackBannerEntryPoint,
		entryPointParams,
	);
	if (!hasLoadedEntrypoint.current) {
		entryPointActions.load();
		hasLoadedEntrypoint.current = true;
	}
	return { entryPointReferenceSubject };
};

export const AsyncJpdBlueprintsFeedbackBanner = (): React.JSX.Element => {
	const { entryPointReferenceSubject } = useEntrypoint();

	return (
		<JiraEntryPointContainer
			id={ENTRY_POINT_ID}
			packageName={PACKAGE_NAME}
			entryPointReferenceSubject={entryPointReferenceSubject}
			runtimeProps={{}}
		/>
	);
};
